import { TabelPaging } from '../../interfaces/table';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/logger.service';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import { CustomizeResponseService } from '../../services/customize-response.service';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { WarehouseModal } from '../../models/warehose-modal';
import { FocusableHTMLElement } from '../../interfaces/focusable-html-element';

@Component({
  selector: 'app-warehouse-handling-modal',
  templateUrl: './warehouse-handling-modal.component.html',
  styleUrls: ['./warehouse-handling-modal.component.css'],
})
export class WarehouseHandlingModalComponent {
  public constructor(
    private apiService: UserApiService,
    private logger: LoggerService,
    private modalService: NgbModal,
    private responseService: CustomizeResponseService
  ) {
    this.getStocks();
    this.requestModel = new PCSearchRequestModel();
    this.data = new WarehouseModal('', 0, '', '', 0, '', '', '', '', '');
  }

  @Input() modalIsOpen?: boolean;
  @Input() data: WarehouseModal;

  @ViewChild('modalContent') modalContent!: any;

  @Output() parentActionOutput = new EventEmitter<PCTableOutputModel>();

  public loading: boolean = false;
  public shakeFrom: boolean = false;
  public modalLoading: boolean = false;
  public countMessage: string = ``;
  public packageCount: number = 0;
  public destinationMessage: string = ``;
  public stocks: any[] = [];

  public modalSuccessConfirm: boolean = false;
  public endPoint: string = `StockItem`;
  public endPointUrl!: string;

  public sourceStockSelected: any;

  public newItem: any = { count: '', stockId: '' };
  public stockList: any[] = [];
  private focusableItems: FocusableHTMLElement[] = [];
  private rememberItem?: FocusableHTMLElement;
  public requestModel: PCSearchRequestModel;
  public paging?: TabelPaging;

  public ngOnChanges(changes: SimpleChanges) {
    if (
      changes &&
      changes['modalIsOpen'] &&
      changes['modalIsOpen'].currentValue !== undefined
    ) {
      if (changes['modalIsOpen'].currentValue == true) {
        this.openModal(this.modalContent);
      } else if (changes['modalIsOpen'].currentValue == false) {
        this.modalService.dismissAll();
      }
    }
  }

  public openModal(content: any) {
    try {
      this.modalService
        .open(content, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {
            if (result == 'Save click') {
            }
            setTimeout(() => {
              this.modalIsOpen = false;
              this.parentActionOutput.next(
                new PCTableOutputModel('TransferModalClose', null)
              );
            }, 1 * 1000);
          },
          (reason) => {
            setTimeout(() => {
              this.modalIsOpen = false;
              this.parentActionOutput.next(
                new PCTableOutputModel('TransferModalClose', null)
              );
            }, 1 * 1000);
          }
        );
    } catch (error) { }
  }

  public submitModal() {
    if (!this.checkValidation()) {
      return;
    }
    try {
      this.modalLoading = true;
      if (this.newItem.count == null || this.newItem.count == 0) {
        this.logger.addError(
          'تعداد در انبار نمیتواند خالی و یا صفر باشد',
          false
        );
        return;
      }
      if (this.newItem.stockId == null || this.newItem.stockId == '') {
        this.logger.addError('لطفا یک انبار را انتخاب نمایید ', false);
        return;
      }

      // if (this.editableItem.stocks.length >= 3) {
      //   this.logger.addError(
      //     'امکان انتقال یک دارو به بیش از 3 انبار امکان پذیر نیست ',
      //     false
      //   );
      //   return;
      // }

      let url = `InventoryDetail/Transfer`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        this.loading = false;
        return;
      }

      var jsonText = JSON.stringify(this.data);
      this.apiService.postItem(new ApiRequestModel(url, this.data)).subscribe(
        (result) => {
          this.modalLoading = false;
          if (result.succeeded) {
            this.modalService.dismissAll();

            this.modalSuccessConfirm = true;

            this.parentActionOutput.next(
              new PCTableOutputModel('ReteyListView', this.data.drugId)
            );
          } else {
            this.logger.addError(result.errorMessages[0], false);
          }
        },

        (error) => {
          this.apiService.AddErrorLog(error);
          this.modalLoading = false;
        },
        () => {
          this.modalLoading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.modalLoading = false;
    }
  }

  public nextFocus() {
    if (this.focusableItems.length == 0) {
      // this.generateFocusList();
    }

    let focusedElement = document.activeElement;

    let currentItemInArray = this.focusableItems.find(
      (current) =>
        current.element.id == focusedElement?.id &&
        current.element.classList == focusedElement?.classList
    );

    if (currentItemInArray == null && this.rememberItem != null) {
      if (
        this.rememberItem.element.className.indexOf('drop-down-box') >= 0 &&
        this.rememberItem.element.className.indexOf('drop-down-box-open') >= 0
      ) {
        return;
      } else {
        currentItemInArray = this.rememberItem;
      }
    }

    const currentItemIndex =
      currentItemInArray == undefined ? 0 : currentItemInArray.index + 1;

    const nextItemIndex =
      currentItemIndex == this.focusableItems.length ? 7 : currentItemIndex;

    const needFocus = this.focusableItems[nextItemIndex];

    needFocus.element.focus();
    this.rememberItem = needFocus;

    if (needFocus.element instanceof HTMLInputElement) {
      needFocus.element.select();
    }
  }

  public getStocks(): void {
    try {
      this.loading = true;
      let url = `Stock?pageNumber=1&pageSize=1000&paging=true&orderBy=&direction=asc`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            this.stockList = result.data?.items.map((current) => ({
              id: current.id,
              name: current.name,
              persianName: current.title,
            }));
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }

    setTimeout(() => { }, 700);

    setTimeout(() => {
      let selectStockPage = document.getElementById('StockDetail');
      if (selectStockPage) {
        selectStockPage.classList.remove('animate__backInDown');
      }
    }, 2 * 1000);
  }

  public packageKeyUp() {
    this.data.count = this.packageCount * this.data.drugPackageCount;

    this.checkValidation();
  }

  public countKeyUp(): boolean {
    this.checkValidation();

    if (this.data.count % this.data.drugPackageCount != 0) {
      if (this.countMessage == ``) {
        this.countMessage = `مغایرت در بسته بندی`;
      }
      return false;
    } else {
      this.packageCount = this.data.count / this.data.drugPackageCount;
      return true;
    }
  }

  public checkValidation(): boolean {
    let validate = true;
    if (this.data.count > this.data.maxTransfer) {
      this.countMessage = `مقدار انتقال از مقدار موجودی بیشتر است`;
      this.data.count = this.data.maxTransfer;
      validate = false;
    }
    else if (this.data.count <= 0) {
      this.countMessage = `مقدار انتقال نمیتواند کوچکتر از 1 باشد`;
      this.data.count = this.data.drugPackageCount;
      validate = false;
    }
    this.countMessage = ``;

    // if (this.data.destinationStockId == '' || this.data.destinationStockId == null) {
    //   this.destinationMessage = 'انبار مقصد انتخاب نشده';
    //   validate = false;
    // }
    // else {
    //     this.data.destinationStockId?;
    //   }

    return validate;
  }

  public beTrue() {
    if (!this.countKeyUp()) {
      this.packageCount =
        this.data.count / this.data.drugPackageCount -
        (this.data.count % this.data.drugPackageCount) /
        this.data.drugPackageCount;
      this.data.count = this.packageCount * this.data.drugPackageCount;
    }
  }

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Successed':
        this.modalSuccessConfirm = false;
        break;
      default:
        break;
    }
  }
}
